






















































import { BankCustodian } from "@/admin/types";
import {
  Vue,
  Component,
  Watch,
} from "@/shared/vuepack";
import { Home } from "@/employee/route-names";
import { HsabAccountType } from "@/shared/types";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import HsabAccountListItem from "./HsabAccountListItem.vue";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import LoginWrapper from "@/shared/components/ui/LoginWrapper.vue";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component({
  components: {
    GenericLoadingSpinner,
    HsabAccountListItem,
    SsoDeepLink,
    LoginWrapper,
  }
})
export default class HsabAccountSelection extends Vue {
  showOnlyActiveAccounts = true;
  readonly showOnlyActiveAccountsOptions = [
    { text: "Show active accounts only", value: true },
    { text: "Show all accounts", value: false }
  ];

  hsabAccountsStore = useHsabAccountsStore();
  custodianSettingsStore = useCustodianSettingsStore();

  HsabAccountType: any = HsabAccountType;

  created () {
    this.redirectIfNotHsaBank();
    this.hsabAccountsStore.getHsabAccounts();

    if (this.hsabAccountsStore.userHasAnyNotionalAccounts && !this.hsabAccountsStore.userHasActiveNotionalAccounts) {
      // only inactive notional accounts
      this.showOnlyActiveAccounts = false;
    }
  }

  get isLoaded () {
    return this.hsabAccountsStore.allHsabAccountsLoaded;
  }

  get isNotHsaBankUser () {
    return this.custodianSettingsStore.isLoaded && this.custodianSettingsStore.userCustodian !==
        BankCustodian.HsaBank;
  }

  get accounts () {
    if (this.showOnlyActiveAccounts) {
      return this.hsabAccountsStore.allHsabAccounts.filter(a => a.isActive);
    }

    return this.hsabAccountsStore.allHsabAccounts;
  }

  @Watch("custodianSettingsStore.isLoaded")
  redirectIfNotHsaBank () {
    if (this.isNotHsaBankUser) {
      this.returnToDashboard();
    }
  }

  returnToDashboard () {
    this.$router.push({ name: Home });
  }
}
